import { useState, useEffect } from "react"
import { Control } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
    FreeTextQuestionCard,
    SelectQuestionCard,
    MultipleChoiceQuestionCard,
    NumberQuestionCard,
    PercentQuestionCard,
    MinutesQuestionCard,
    TimeOfDayQuestionCard,
    ImageQuestionCard,
    ScaleSliderQuestionCard,
    YesNoQuestionCard,
    MultiChipQuestionCard
} from "../../../IntakeScreeningCandidate/IntakeCardsContent"
// import MultiChipQuestionCard from "../../../IntakeScreeningCandidate/IntakeCardsContent/MultiChipQuestionCard/MultiChipQuestionCard"
import { ExerciseQuestionType } from "@prisma/client"
import GuidelineCard from "../WebBasedEventCardContent/GuidelineCard"

export enum LayoutVariant {
    DESKTOP = "desktop",
    MOBILE = "mobile"
}

const buildExerciseSurveyUtil = (questions: any, control: Control<Record<any, any>>, errors: any) => {
    const { t } = useTranslation()
    const [exerciseQuestions, setExerciseQuestions] = useState<any>([])

    useEffect(() => {
        if (questions) {
            setExerciseQuestions(questions)
        }
    }, [questions])

    const cards: React.ReactNode[] = []

    exerciseQuestions
        .sort((a: any, b: any) => a.pos - b.pos)
        .forEach((question: any) => {
            const errorMessage = errors?.exerciseAnswers?.[question.id]?.message
                ? t("exercise:question_is_required")
                : ""

            switch (question.type) {
                case ExerciseQuestionType.text:
                    cards.push(<GuidelineCard key={question.question} description={question.question} />)
                    break

                case ExerciseQuestionType.free_text:
                    cards.push(
                        <FreeTextQuestionCard
                            key={question.question}
                            question={question}
                            control={control}
                            error={errorMessage}
                            layoutVariant={LayoutVariant.MOBILE}
                            namePrefix="exerciseAnswers"
                        />
                    )
                    break

                case ExerciseQuestionType.yes_no:
                    cards.push(
                        <YesNoQuestionCard
                            key={question.question}
                            question={question}
                            control={control}
                            error={errorMessage}
                            layoutVariant={LayoutVariant.MOBILE}
                            namePrefix="exerciseAnswers"
                        />
                    )
                    break

                case ExerciseQuestionType.select:
                    cards.push(
                        <SelectQuestionCard
                            key={question.question}
                            question={question}
                            control={control}
                            error={errorMessage}
                            layoutVariant={LayoutVariant.MOBILE}
                            namePrefix="exerciseAnswers"
                        />
                    )
                    break

                case ExerciseQuestionType.multiple_choice:
                    cards.push(
                        <MultipleChoiceQuestionCard
                            key={question.question}
                            question={question}
                            control={control}
                            error={errorMessage}
                            layoutVariant={LayoutVariant.MOBILE}
                            namePrefix="exerciseAnswers"
                        />
                    )
                    break

                case ExerciseQuestionType.number:
                    cards.push(
                        <NumberQuestionCard
                            key={question.question}
                            question={question}
                            control={control}
                            error={errorMessage}
                            layoutVariant={LayoutVariant.MOBILE}
                            namePrefix="exerciseAnswers"
                        />
                    )
                    break

                case ExerciseQuestionType.percent:
                    cards.push(
                        <PercentQuestionCard
                            key={question.question}
                            question={question}
                            control={control}
                            error={errorMessage}
                            layoutVariant={LayoutVariant.MOBILE}
                            namePrefix="exerciseAnswers"
                        />
                    )
                    break

                case ExerciseQuestionType.minutes:
                    cards.push(
                        <MinutesQuestionCard
                            key={question.question}
                            question={question}
                            control={control}
                            error={errorMessage}
                            layoutVariant={LayoutVariant.MOBILE}
                            namePrefix="exerciseAnswers"
                        />
                    )
                    break

                case ExerciseQuestionType.time_of_day:
                    cards.push(
                        <TimeOfDayQuestionCard
                            key={question.question}
                            question={question}
                            control={control}
                            error={errorMessage}
                            layoutVariant={LayoutVariant.MOBILE}
                            namePrefix="exerciseAnswers"
                        />
                    )
                    break

                case ExerciseQuestionType.image:
                    cards.push(
                        <ImageQuestionCard
                            key={question.question}
                            question={question}
                            control={control}
                            error={errorMessage}
                            layoutVariant={LayoutVariant.MOBILE}
                            namePrefix="exerciseAnswers"
                        />
                    )
                    break

                case ExerciseQuestionType.scale:
                    cards.push(
                        <ScaleSliderQuestionCard
                            key={question.question}
                            question={question}
                            control={control}
                            error={errorMessage}
                            layoutVariant={LayoutVariant.MOBILE}
                            namePrefix="exerciseAnswers"
                        />
                    )
                    break

                case ExerciseQuestionType.multi_chip:
                    cards.push(
                        <MultiChipQuestionCard
                            key={question.question}
                            question={question}
                            control={control}
                            error={errorMessage}
                            layoutVariant={LayoutVariant.MOBILE}
                            namePrefix="exerciseAnswers"
                        />
                    )
                    break
            }
        })

    return cards
}

export default buildExerciseSurveyUtil
